module.exports = __webpack_public_path__ + "img/recon.207816ec.svg";